module.exports = __webpack_public_path__ + "img/zhezhao-3.a6af0291.png";